<ng-container *ngIf="mapControls$ | async as mapControls">
  <div [ngClass]="drawer.opened ? 'map-controls-container drawer-open' : 'map-controls-container drawer-closed'">
    <div class="controls-container-left">
      <div
        (click)="toggleMapToolHelp()"
        [style.visibility]="readOnlyMap ? 'hidden' : 'visible'"
        class="heading info-icon">
        <fa-icon [icon]="['fas', 'question-circle']"></fa-icon>
      </div>
      <div
        *ngIf="showInfoToolTip"
        [style.visibility]="readOnlyMap || hideInfoTooltip ? 'hidden' : 'visible'"
        class="info-tooltip left">
        <span>If you need more information about the map tools, just click the question mark icon</span>
        <button (click)="closeInfoTooltip()" mat-stroked-button type="button" data-cy="map-tools-ok-button">
          Ok, Got it
        </button>
      </div>
      @if (readOnlyMap || currentUser?.isAdmin) {
        <div (click)="handleSiteDetailsClick()" class="heading command" data-cy="site-details">
          <fa-icon [icon]="['far', 'arrow-left']"></fa-icon>
          View Site Details
        </div>
      }
      @if (readOnlyMap || (!readOnlyMap && !approvalRequired)) {
        <div (click)="handleEditParcelsClick()" class="heading command" data-cy="view-parcels">
          <span>{{ readOnlyMap ? 'View' : 'Edit' }} Parcels</span>
        </div>
      }
    </div>
    <div [class.hidden-map-tools]="readOnlyMap || approvalRequired">
      <div class="heading show-tablet-landscape">Map Tools</div>
      <div
        #tooltip1="matTooltip"
        (click)="toggleMapControlsEvent('standSelector'); tooltip1.toggle()"
        [ngClass]="
          mapControls.standSelector
            ? 'icon-container__active show-tablet-landscape'
            : 'icon-container__inactive show-tablet-landscape'
        "
        data-cy="stand-selector"
        matTooltip="Suggested Stand&#13;Selection Tool"
        matTooltipClass="fc-tooltip-map">
        <fa-icon
          [class]="mapControls.standSelector ? 'fa-icon light-green size-23' : 'fa-icon med-light-gray size-23'"
          [icon]="['fal', 'hand-pointer']"></fa-icon>
      </div>
      <div
        #tooltip2="matTooltip"
        (click)="toggleMapControlsEvent('drawPolygonMode'); tooltip2.toggle()"
        [ngClass]="
          mapControls.drawPolygonMode
            ? 'icon-container__active show-tablet-landscape'
            : 'icon-container__inactive show-tablet-landscape'
        "
        data-cy="polygon-selector"
        matTooltip="Draw Tool"
        matTooltipClass="fc-tooltip-map">
        <fa-icon
          [class]="mapControls.drawPolygonMode ? 'fa-icon light-green size-23' : 'fa-icon med-light-gray size-23'"
          [icon]="['fal', 'pen-nib']"></fa-icon>
      </div>
      <div
        #tooltip3="matTooltip"
        (click)="toggleMapControlsEvent('editMode'); tooltip3.toggle()"
        [ngClass]="
          mapControls.editMode
            ? 'icon-container__active show-tablet-landscape'
            : 'icon-container__inactive show-tablet-landscape'
        "
        matTooltip="Edit Tool"
        matTooltipClass="fc-tooltip-map">
        <fa-icon
          [class]="mapControls.editMode ? 'fa-icon light-green size-23' : 'fa-icon med-light-gray size-23'"
          [icon]="['fal', 'draw-polygon']"></fa-icon>
      </div>
      <div
        #tooltip13="matTooltip"
        (click)="handleKMLClicked(); tooltip13.toggle()"
        class="icon-container__inactive show-tablet-landscape"
        data-cy="kml-upload-link"
        matTooltip="KML Upload"
        matTooltipClass="fc-tooltip-map">
        <fa-icon class="kml-icon-wrapper fa-icon med-light-gray size-20" [icon]="['fal', 'map']"></fa-icon>
        <span class="kml-icon-overlay">KML</span>
      </div>
      <div
        #toolsTrigger="cdkOverlayOrigin"
        (click)="showMapToolsOverlay = !showMapToolsOverlay"
        [ngClass]="
          showMapToolsOverlay
            ? 'hide-tablet-landscape heading horizontal-padding layers-active'
            : 'hide-tablet-landscape heading horizontal-padding layers-inactive'
        "
        cdkOverlayOrigin>
        Map Tools
        <fa-icon [icon]="['fas', 'expand-wide']"></fa-icon>
      </div>

      <ng-template
        [cdkConnectedOverlayOpen]="showMapToolsOverlay"
        [cdkConnectedOverlayOrigin]="toolsTrigger"
        cdkConnectedOverlay>
        <div class="map-tools-overlay overlay show-map-overlay">
          <div
            (click)="toggleMapControlsEvent('standSelector')"
            [ngClass]="mapControls.standSelector ? 'map-tools__active' : 'map-tools__inactive'">
            <fa-icon [icon]="['fal', 'hand-pointer']"></fa-icon>
            Selector Tool
          </div>
          <div
            (click)="toggleMapControlsEvent('drawPolygonMode')"
            [ngClass]="mapControls.drawPolygonMode ? 'map-tools__active' : 'map-tools__inactive'">
            <fa-icon [icon]="['fal', 'pen-nib']"></fa-icon>
            Draw Tool
          </div>
          <div
            (click)="toggleMapControlsEvent('editMode')"
            [ngClass]="mapControls.editMode ? 'map-tools__active' : 'map-tools__inactive'">
            <fa-icon [icon]="['fal', 'draw-polygon']"></fa-icon>
            Edit Tool
          </div>
          <div (click)="handleKMLClicked()" class="map-tools__inactive">
            <fa-icon [icon]="['fal', 'map']"></fa-icon>
            KML Upload
          </div>
          <div (click)="showMapToolsOverlay = false" class="close-overlay">Close</div>
        </div>
      </ng-template>
    </div>

    <div class="controls-container-center">
      <mat-button-toggle-group>
        <mat-button-toggle
          (click)="toggleMapControlsEvent('displayContour')"
          [ngClass]="
            mapControls.displayContour === MapDisplayTypeEnum.CONTOUR ? 'map-view-button' : 'map-view-button selected'
          "
          value="sat">
          <span>Satellite</span>
          <span class="condensed-text">Satellite</span>
        </mat-button-toggle>
        <mat-button-toggle
          (click)="toggleMapControlsEvent('displayContour')"
          [ngClass]="
            mapControls.displayContour === MapDisplayTypeEnum.CONTOUR ? 'map-view-button selected' : 'map-view-button'
          "
          value="topo">
          <span>Topo</span>
          <span class="condensed-text">Topo</span>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="controls-container-right">
      <div *ngIf="showParcelTip" [style.visibility]="hideParcelTip ? 'hidden' : 'visible'" class="info-tooltip right">
        <span>
          It looks like your parcels are spread far apart. Click the sign post icon above to quickly navigate between
          your parcels.
        </span>
        <button (click)="closeParcelTooltip()" mat-stroked-button type="button" data-cy="map-tools-ok-button">
          Ok, Got it
        </button>
      </div>
      <div class="heading horizontal-padding show-desktop">Layers</div>
      <div
        #tooltip4="matTooltip"
        (click)="toggleMapControlsEvent('displayPublicLand'); tooltip4.toggle()"
        *ngIf="currentUser && currentUser.isAdmin"
        [ngClass]="mapControls.displayPublicLand ? 'icon-container__active round' : 'icon-container__inactive round'"
        class="show-desktop"
        matTooltip="Red Flag"
        matTooltipClass="fc-tooltip-map">
        <fa-icon [icon]="['far', 'square-dashed']"></fa-icon>
      </div>
      <div class="forest-button-container show-desktop">
        <ng-container *ngIf="mapControls.standSelector; else enableSuggestedStandSelectorBlock">
          <div class="locked-button">
            <fa-icon [icon]="['far', 'lock']" class="white"></fa-icon>
          </div>
          <div
            #tooltip5="matTooltip"
            (click)="tooltip5.toggle()"
            [ngClass]="
              mapControls.suggestedStandsSelector
                ? 'forest-icon-container__active round locked-pointer'
                : 'forest-icon-container__inactive round locked-pointer'
            "
            matTooltip="Suggested Stands&#13;[Locked in Stand Selector Tool]"
            matTooltipClass="fc-tooltip-map">
            <fa-icon
              [class]="
                mapControls.suggestedStandsSelector ? 'fa-icon light-green size-23' : 'fa-icon med-light-gray size-23'
              "
              [icon]="['fas', 'border-all']"></fa-icon>
          </div>
        </ng-container>

        <ng-template #enableSuggestedStandSelectorBlock>
          <div
            #tooltip6="matTooltip"
            (click)="toggleMapControlsEvent('suggestedStandsSelector'); tooltip6.toggle()"
            [ngClass]="
              mapControls.suggestedStandsSelector
                ? 'forest-icon-container__active round'
                : 'forest-icon-container__inactive round'
            "
            class="stand-selector"
            matTooltip="Suggested Stands"
            matTooltipClass="fc-tooltip-map">
            <fa-icon
              [class]="
                mapControls.suggestedStandsSelector ? 'fa-icon light-green size-23' : 'fa-icon med-light-gray size-23'
              "
              [icon]="['fas', 'border-all']"></fa-icon>
          </div>
        </ng-template>
      </div>

      <div
        #tooltip9="matTooltip"
        (click)="toggleMapControlsEvent('displayStands'); tooltip9.toggle()"
        [ngClass]="
          mapControls.displayStands
            ? 'icon-container__active round show-desktop'
            : 'icon-container__inactive round show-desktop'
        "
        matTooltip="Included Area"
        matTooltipClass="fc-tooltip-map">
        <fa-icon
          [class]="mapControls.displayStands ? 'fa-icon light-green size-23' : 'fa-icon med-light-gray size-23'"
          [icon]="['far', 'square-dashed-circle-plus']"></fa-icon>
      </div>
      <div class="forest-button-container show-desktop">
        <ng-container *ngIf="mapControls.standSelector; else enableStandSelectorBlock">
          <div class="locked-button">
            <fa-icon [icon]="['far', 'lock']" class="white"></fa-icon>
          </div>
          <div
            #tooltip7="matTooltip"
            (click)="tooltip7.toggle()"
            [ngClass]="
              mapControls.displayForest
                ? 'forest-icon-container__active round locked-pointer'
                : 'forest-icon-container__inactive round'
            "
            matTooltip="Forest&#13;[Locked in Stand Selector Tool]"
            matTooltipClass="fc-tooltip-map">
            <fa-icon
              [class]="mapControls.displayForest ? 'fa-icon light-green size-23' : 'fa-icon med-light-gray size-23'"
              [icon]="['fas', 'tree-deciduous']"></fa-icon>
          </div>
        </ng-container>
        <ng-template #enableStandSelectorBlock>
          <div
            #tooltip8="matTooltip"
            (click)="toggleMapControlsEvent('displayForest'); tooltip8.toggle()"
            [ngClass]="
              mapControls.displayForest
                ? 'forest-icon-container__active round'
                : 'forest-icon-container__inactive round'
            "
            matTooltip="Forest"
            matTooltipClass="fc-tooltip-map">
            <fa-icon
              [class]="mapControls.displayForest ? 'fa-icon light-green size-23' : 'fa-icon med-light-gray size-23'"
              [icon]="['fas', 'tree-deciduous']"></fa-icon>
          </div>
        </ng-template>
      </div>
      <div
        #tooltip9="matTooltip"
        (click)="toggleMapControlsEvent('displayWaterways'); tooltip9.toggle()"
        [ngClass]="
          mapControls.displayWaterways
            ? 'icon-container__active round show-desktop'
            : 'icon-container__inactive round show-desktop'
        "
        matTooltip="Rivers and Streams"
        matTooltipClass="fc-tooltip-map">
        <fa-icon
          [class]="mapControls.displayWaterways ? 'fa-icon light-green size-23' : 'fa-icon med-light-gray size-23'"
          [icon]="['fas', 'water']"></fa-icon>
      </div>
      <div
        #tooltip10="matTooltip"
        (click)="toggleMapControlsEvent('displayRoads'); tooltip10.toggle()"
        [ngClass]="
          mapControls.displayRoads
            ? 'icon-container__active round show-desktop'
            : 'icon-container__inactive round show-desktop'
        "
        matTooltip="Roads"
        matTooltipClass="fc-tooltip-map">
        <fa-icon
          [class]="mapControls.displayRoads ? 'fa-icon light-green size-23' : 'fa-icon med-light-gray size-23'"
          [icon]="['fas', 'road']"></fa-icon>
      </div>
      <div
        *ngIf="mapControls.displayKMLUpload !== null"
        #tooltip12="matTooltip"
        (click)="toggleMapControlsEvent('displayKMLUpload'); tooltip12.toggle()"
        [ngClass]="
          mapControls.displayKMLUpload
            ? 'icon-container__active round show-desktop'
            : 'icon-container__inactive round show-desktop'
        "
        matTooltip="KML"
        matTooltipClass="fc-tooltip-map">
        <fa-icon
          [class]="
            mapControls.displayKMLUpload
              ? 'kml-icon-wrapper fa-icon light-green size-20'
              : 'kml-icon-wrapper fa-icon med-light-gray size-20'
          "
          [icon]="['fas', 'map']"></fa-icon>
        <span class="kml-icon-overlay">KML</span>
      </div>

      <div
        #layersTrigger="cdkOverlayOrigin"
        (click)="showLayersOverlay = !showLayersOverlay"
        [ngClass]="
          showLayersOverlay
            ? 'hide-desktop heading horizontal-padding layers-active'
            : 'hide-desktop heading horizontal-padding layers-inactive'
        "
        cdkOverlayOrigin>
        Layers
        <fa-icon [icon]="['fas', 'caret-up']"></fa-icon>
      </div>

      <ng-template
        [cdkConnectedOverlayOpen]="showLayersOverlay"
        [cdkConnectedOverlayOrigin]="layersTrigger"
        cdkConnectedOverlay>
        <div class="layers-select-overlay overlay hide-desktop">
          <div (click)="!mapControls.standSelector && toggleMapControlsEvent('suggestedStandsSelector')">
            <ng-container *ngIf="!mapControls.suggestedStandsSelector; else visibleStands">
              <fa-icon [icon]="['fas', 'eye-slash']" class="green size-20"></fa-icon>
            </ng-container>
            <ng-template #visibleStands>
              <fa-icon [icon]="['fas', 'eye']" class="green size-20"></fa-icon>
            </ng-template>
            <fa-icon [icon]="['fas', 'border-all']"></fa-icon>
            Suggested Stands
            <ng-container *ngIf="mapControls.standSelector">
              <fa-icon [icon]="['far', 'lock']" class="green size-20"></fa-icon>
            </ng-container>
          </div>
          <div (click)="toggleMapControlsEvent('displayStands')">
            <ng-container *ngIf="!mapControls.displayStands; else visibleStands">
              <fa-icon [icon]="['fas', 'eye-slash']" class="green size-20"></fa-icon>
            </ng-container>
            <ng-template #visibleStands>
              <fa-icon [icon]="['fas', 'eye']" class="green size-20"></fa-icon>
            </ng-template>
            <fa-icon [icon]="['fas', 'tree']"></fa-icon>
            Included Area
          </div>
          <div (click)="!mapControls.standSelector && toggleMapControlsEvent('displayForest')">
            <ng-container *ngIf="!mapControls.displayForest; else visibleForests">
              <fa-icon [icon]="['fas', 'eye-slash']" class="green size-20"></fa-icon>
            </ng-container>
            <ng-template #visibleForests>
              <fa-icon [icon]="['fas', 'eye']" class="green size-20"></fa-icon>
            </ng-template>
            <fa-icon [icon]="['fas', 'tree']"></fa-icon>
            Forest
            <ng-container *ngIf="mapControls.standSelector">
              <fa-icon [icon]="['far', 'lock']" class="green size-20"></fa-icon>
            </ng-container>
          </div>
          <div (click)="toggleMapControlsEvent('displayWaterways')">
            <ng-container *ngIf="!mapControls.displayWaterways; else visibleWaterways">
              <fa-icon [icon]="['fas', 'eye-slash']" class="green size-20"></fa-icon>
            </ng-container>
            <ng-template #visibleWaterways>
              <fa-icon [icon]="['fas', 'eye']" class="green size-20"></fa-icon>
            </ng-template>
            <fa-icon [icon]="['fas', 'water']"></fa-icon>
            Rivers and Streams
          </div>
          <div (click)="toggleMapControlsEvent('displayRoads')">
            <ng-container *ngIf="!mapControls.displayRoads; else visibleRoads">
              <fa-icon [icon]="['fas', 'eye-slash']" class="green size-20"></fa-icon>
            </ng-container>
            <ng-template #visibleRoads>
              <fa-icon [icon]="['fas', 'eye']" class="green size-20"></fa-icon>
            </ng-template>
            <fa-icon [icon]="['fas', 'road']"></fa-icon>
            Roads
          </div>
          <div (click)="toggleMapControlsEvent('displayPublicLand')" *ngIf="currentUser && currentUser.isAdmin">
            <ng-container *ngIf="!mapControls.displayPublicLand; else visiblePublicLand">
              <fa-icon [icon]="['fas', 'eye-slash']" class="green size-20"></fa-icon>
            </ng-container>
            <ng-template #visiblePublicLand>
              <fa-icon [icon]="['fas', 'eye']" class="green size-20"></fa-icon>
            </ng-template>
            <fa-icon [icon]="['far', 'flag']"></fa-icon>
            Red Flag
          </div>
          <div *ngIf="mapControls.displayKMLUpload !== null" (click)="toggleMapControlsEvent('displayKMLUpload')">
            <ng-container *ngIf="!mapControls.displayKMLUpload; else visibleKMLLayer">
              <fa-icon [icon]="['fas', 'eye-slash']" class="green size-20"></fa-icon>
            </ng-container>
            <ng-template #visibleKMLLayer>
              <fa-icon [icon]="['fas', 'eye']" class="green size-20"></fa-icon>
            </ng-template>
            <fa-icon [icon]="['far', 'map']"></fa-icon>
            KML
          </div>
          <div (click)="showLayersOverlay = false" class="close-overlay">Close</div>
        </div>
      </ng-template>
    </div>
    <div>
      <div *ngIf="currentUser && currentUser.isAdmin" class="heading horizontal-padding right">
        <fa-icon
          (click)="generateMap.emit()"
          [icon]="['fal', 'map']"
          class="gray size-20 clickable"
          matTooltip="Generate a New Map"
          matTooltipClass="fc-tooltip-map"></fa-icon>
      </div>
      <div class="heading horizontal-padding right">
        <fa-icon
          (click)="showParcelHelp()"
          [icon]="['fal', 'signs-post']"
          class="gray size-20 clickable"
          matTooltip="View Parcels"
          matTooltipClass="fc-tooltip-map"></fa-icon>
      </div>
      <div class="heading horizontal-padding right">
        <fa-icon
          #tooltip11="matTooltip"
          (click)="downloadKML(); tooltip11.toggle()"
          [icon]="['fal', 'map']"
          class="kml-icon-wrapper gray size-20 clickable"
          matTooltip="Downlad KML"
          matTooltipClass="fc-tooltip-map"></fa-icon>
        <span class="kml-icon-overlay kml-download-icon">KML</span>
      </div>
    </div>
  </div>
  <div *ngIf="showParcels" class="map-tool-help parcels">
    <div class="header">
      Selected Parcels
      <fa-icon (click)="showParcelHelp()" [icon]="['far', 'xmark']" class="clickable gray size-20"></fa-icon>
    </div>
    <ng-container>
      <div class="help" *ngFor="let selectedParcel of selectedParcels; index as i">
        <fc-parcel-item [parcel]="selectedParcel"></fc-parcel-item>
      </div>
    </ng-container>
  </div>
  <div *ngIf="showMapToolHelp" class="map-tool-help">
    <div class="header">
      Map Tool Help
      <fa-icon (click)="toggleMapToolHelp()" [icon]="['far', 'xmark']" class="clickable gray size-20"></fa-icon>
    </div>
    <div class="help">
      <fa-icon [icon]="['fal', 'hand-pointer']" class="icon-button"></fa-icon>
      <div>
        Use the
        <span class="highlight">Selection Tool</span>
        to select objects on the map like tree species stands. Click once on the stands to see the estimated value of
        the land and add it to your Carbon Offset Site.
      </div>
    </div>
    <div class="help">
      <fa-icon [icon]="['fal', 'pen-nib']" class="icon-button"></fa-icon>
      <div>
        Click the
        <span class="highlight">Draw Tool</span>
        to manually draw custom shapes on your property. With the draw tool selected, click on the map to create points.
        To complete the custom shape, click on the first node or hit the Enter key.
      </div>
    </div>
    <div class="help">
      <fa-icon [icon]="['fal', 'draw-polygon']" class="icon-button"></fa-icon>
      <div>
        Select the
        <span class="highlight">Edit Tool</span>
        to add, edit, or delete parts of stands or custom shapes that you have added to your site. Select the point
        between two nodes to add a new node. Select or delete multiple nodes by pressing shift and clicking. Press the
        Delete key to remove selected nodes.
      </div>
    </div>
    <div class="help">
      <fa-icon [icon]="['fal', 'map']" class="icon-button"></fa-icon>
      <div>
        Select the
        <span class="highlight">KML Tool</span>
        to import a KML/KMZ into your site. You can select a previously imported KML or upload a new KML/KMZ file to
        your site. Selecting this option will removal all existing stands from your site, and import any stands that are
        located in the KML/KMZ definition you upload.
      </div>
    </div>
  </div>
</ng-container>
